import { type FC } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAppSelector } from '@~/hooks';

import { AUTH_ROUTES, DASHBOARD_ROUTES } from '../route-constants';

// Imported lazily
const AuthRoutesWrapper: FC = () => {
  const loggedIn = useAppSelector(store => store.auth.loggedIn);
  const location = useLocation();
  const { pathname, search } = location;

  if (loggedIn) {
    return <Navigate to={DASHBOARD_ROUTES.ROOT.PATH} replace />;
  }

  // Redirecting /signup to /signup-lp
  if (pathname === '/signup' || pathname === '/signup/') {
    return <Navigate to={`${AUTH_ROUTES.SIGNUP_LP.PATH}${search}`} replace />;
  }

  return <Outlet />;
};

export default AuthRoutesWrapper;
